module.exports = __webpack_public_path__ + "img/male_icon.a17a6480.png";